import { render, staticRenderFns } from "./customer-projects.vue?vue&type=template&id=333424f8&scoped=true"
import script from "./customer-projects.vue?vue&type=script&lang=js"
export * from "./customer-projects.vue?vue&type=script&lang=js"
import style0 from "./customer-projects.vue?vue&type=style&index=0&id=333424f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333424f8",
  null
  
)

export default component.exports